type List = {
  [key: string]: {
    text: string
    value: string
  }[]
}

const dataAttr = "data-nest-select"

function updateChildOptions(
  parentEl: HTMLSelectElement,
  childEl: HTMLSelectElement,
  list: List,
  dataId: string
) {
  const oldValue = childEl.value

  const optionEls = [
    ...childEl.querySelectorAll(`[${dataAttr}-option="${dataId}"]`),
  ] as HTMLOptionElement[]
  optionEls.forEach((optionEl) => optionEl.remove())

  const value = parentEl.value
  const items = list[value] || []

  items.forEach((item) => {
    const optionEl = document.createElement("option")
    optionEl.value = item.value
    optionEl.textContent = item.text
    optionEl.setAttribute(`${dataAttr}-option`, dataId)
    childEl.appendChild(optionEl)
  })

  if (childEl.value !== oldValue) {
    childEl.dispatchEvent(new Event("change"))
  }
}

export function initNestSelect() {
  const parentEls = [
    ...document.querySelectorAll(`[${dataAttr}-parent]`),
  ] as HTMLSelectElement[]

  if (!parentEls.length) return

  for (const parentEl of parentEls) {
    const dataId = parentEl.getAttribute(`${dataAttr}-parent`)

    if (!dataId) continue

    const childEl = document.querySelector(
      `[${dataAttr}-child="${dataId}"]`
    ) as HTMLSelectElement
    const listEl = document.querySelector(
      `[${dataAttr}-list="${dataId}"]`
    ) as HTMLScriptElement

    if (!childEl || !listEl) continue

    const list: List = JSON.parse(listEl.textContent || "{}")

    if (!list || !Object.keys(list).length) continue

    for (const parentEl of parentEls) {
      parentEl.addEventListener("change", () => {
        updateChildOptions(parentEl, childEl, list, dataId)
      })

      const form = parentEl.closest("form")

      if (form) {
        form.addEventListener("reset", () => {
          requestAnimationFrame(() => {
            updateChildOptions(parentEl, childEl, list, dataId)
          })
        })
      }
    }
  }
}

// データの設定が完了してから初期化を実行
document.addEventListener('souoba-shindan-form-data-initialized', () => {
  initNestSelect()
})
